module.exports = __webpack_public_path__ + "static/Prifender-8a99656f7d629be557ffe3c0a7257ae1.jpg";